import { toast } from 'react-toastify';

/**
 * @description Принимает на вход payload ошибки и ответа и вызывает toast
 * @param data
 * @param error
 * @param successText
 * @param errorText
 */
const useResponseHandler = (data: unknown, error: unknown, successText: string, errorText: string) => {
  if (error !== undefined) toast.error(errorText);
  if (data) toast.success(successText);
};

export { useResponseHandler };
